import { rutFormat } from 'rut-helpers'
import moment from 'moment'
import numeral from 'numeral'
import formatMoney from 'accounting-js/lib/formatMoney.js'
import { each, template, isEmpty, isArray, isString } from 'lodash'

moment.locale('es')

const currencies = [
  { id: 'USD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'US', name: 'Dólar estadounidense', conversion: null },
  { id: 'ARS', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'AR', name: 'Peso argentino', conversion: null },
  { id: 'AUD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'AU', name: 'Dólar australiano', conversion: null },
  { id: 'CAD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'CA', name: 'Dólar canadiense', conversion: null },
  { id: 'CHF', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'CH', name: 'Franco suizo', conversion: null },
  { id: 'CLF', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'CL', name: 'Unidad de fomento chilena', conversion: 'CLP' },
  { id: 'CLP', format: { precision: 0, thousand: '.', decimal: ',' }, country: 'CL', name: 'Peso chileno', conversion: null },
  { id: 'CZK', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'CZ', name: 'Corona checa', conversion: null },
  { id: 'DKK', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'DK', name: 'Corona danesa', conversion: null },
  { id: 'EUR', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'EU', name: 'Euro', conversion: null },
  { id: 'GBP', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'GB', name: 'Libra esterlina', conversion: null },
  { id: 'HKD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'HK', name: 'Dólar hongkonés', conversion: null },
  { id: 'HUF', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'HU', name: 'Florín húngaro', conversion: null },
  { id: 'IDR', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'ID', name: 'Rupia indonesia', conversion: null },
  { id: 'ILS', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'IL', name: 'Nuevo shekel israelí', conversion: null },
  { id: 'JPY', format: { precision: 0, thousand: '.', decimal: ',' }, country: 'JP', name: 'Yen japones', conversion: null },
  { id: 'MYR', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'MY', name: 'Ringgit malayo', conversion: null },
  { id: 'MXN', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'MX', name: 'Peso mexicano', conversion: null },
  { id: 'NOK', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'NO', name: 'Corona noruega', conversion: null },
  { id: 'NZD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'NZ', name: 'Dólar neozelandés', conversion: null },
  { id: 'PHP', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'PH', name: 'Peso filipino', conversion: null },
  { id: 'PLN', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'PL', name: 'Zloty polaco', conversion: null },
  { id: 'RUB', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'RU', name: 'Rublo ruso', conversion: null },
  { id: 'SEK', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'SE', name: 'Corona sueca', conversion: null },
  { id: 'SGD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'SG', name: 'Dólar singapurense', conversion: null },
  { id: 'TWD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'TW', name: 'Nuevo dólar taiwanés', conversion: null }
]

const globalInvoiceTypes = ['US1', 'US6', 'CL110']

const baseCountries = [
  { id: 'DE', name: 'Alemania', invoiceTypes: globalInvoiceTypes },
	{ id: 'AR', name: 'Argentina', invoiceTypes: globalInvoiceTypes },
	{ id: 'AU', name: 'Australia', invoiceTypes: globalInvoiceTypes },
	{ id: 'AT', name: 'Austria', invoiceTypes: globalInvoiceTypes },
	{ id: 'BE', name: 'Bélgica', invoiceTypes: globalInvoiceTypes },
	{ id: 'BO', name: 'Bolivia', invoiceTypes: globalInvoiceTypes },
	{ id: 'BR', name: 'Brasil', invoiceTypes: globalInvoiceTypes },
	{ id: 'CA', name: 'Canada', invoiceTypes: globalInvoiceTypes },
	{ id: 'CL', name: 'Chile', invoiceTypes: ['US1', 'US6', 'CL33', 'CL34', 'CL39', 'CL41'] },
	{ id: 'CO', name: 'Colombia', invoiceTypes: globalInvoiceTypes },
	{ id: 'CR', name: 'Costa Rica', invoiceTypes: globalInvoiceTypes },
	{ id: 'DK', name: 'Dinamarca', invoiceTypes: globalInvoiceTypes },
	{ id: 'EC', name: 'Ecuador', invoiceTypes: globalInvoiceTypes },
	{ id: 'SV', name: 'El Salvador', invoiceTypes: globalInvoiceTypes },
	{ id: 'SK', name: 'Eslovaquia', invoiceTypes: globalInvoiceTypes },
	{ id: 'SI', name: 'Eslovenia', invoiceTypes: globalInvoiceTypes },
	{ id: 'ES', name: 'España', invoiceTypes: globalInvoiceTypes },
	{ id: 'US', name: 'Estados Unidos', invoiceTypes: globalInvoiceTypes },
	{ id: 'EE', name: 'Estonia', invoiceTypes: globalInvoiceTypes },
	{ id: 'PH', name: 'Filipinas', invoiceTypes: globalInvoiceTypes },
	{ id: 'FI', name: 'Finlandia', invoiceTypes: globalInvoiceTypes },
	{ id: 'FR', name: 'Francia', invoiceTypes: globalInvoiceTypes },
	{ id: 'GR', name: 'Grecia', invoiceTypes: globalInvoiceTypes },
	{ id: 'GT', name: 'Guatemala', invoiceTypes: globalInvoiceTypes },
	{ id: 'HK', name: 'Hong Kong', invoiceTypes: globalInvoiceTypes },
	{ id: 'HU', name: 'Hungria', invoiceTypes: globalInvoiceTypes },
	{ id: 'ID', name: 'Indonesia', invoiceTypes: globalInvoiceTypes },
	{ id: 'IE', name: 'Irlanda', invoiceTypes: globalInvoiceTypes },
	{ id: 'KY', name: 'Islas Caimán', invoiceTypes: globalInvoiceTypes },
	{ id: 'IL', name: 'Israel', invoiceTypes: globalInvoiceTypes },
	{ id: 'IT', name: 'Italia', invoiceTypes: globalInvoiceTypes },
	{ id: 'JP', name: 'Japon', invoiceTypes: globalInvoiceTypes },
	{ id: 'LV', name: 'Letonia', invoiceTypes: globalInvoiceTypes },
	{ id: 'LT', name: 'Lituania', invoiceTypes: globalInvoiceTypes },
	{ id: 'LU', name: 'Luxemburgo', invoiceTypes: globalInvoiceTypes },
	{ id: 'MY', name: 'Malasia', invoiceTypes: globalInvoiceTypes },
	{ id: 'MX', name: 'México', invoiceTypes: globalInvoiceTypes },
	{ id: 'NO', name: 'Noruega', invoiceTypes: globalInvoiceTypes },
	{ id: 'NZ', name: 'Nueva Zelanda', invoiceTypes: globalInvoiceTypes },
	{ id: 'NL', name: 'Paises Bajos', invoiceTypes: globalInvoiceTypes },
	{ id: 'PA', name: 'Panama', invoiceTypes: globalInvoiceTypes },
	{ id: 'PY', name: 'Paraguay', invoiceTypes: globalInvoiceTypes },
	{ id: 'PE', name: 'Perú', invoiceTypes: globalInvoiceTypes },
	{ id: 'PL', name: 'Polonia', invoiceTypes: globalInvoiceTypes },
	{ id: 'PT', name: 'Portugal', invoiceTypes: globalInvoiceTypes },
	{ id: 'PR', name: 'Puerto Rico', invoiceTypes: globalInvoiceTypes },
	{ id: 'GB', name: 'Reino Unido', invoiceTypes: globalInvoiceTypes },
	{ id: 'CZ', name: 'República Checa', invoiceTypes: globalInvoiceTypes },
	{ id: 'RU', name: 'Rusia', invoiceTypes: globalInvoiceTypes },
	{ id: 'SG', name: 'Singapur', invoiceTypes: globalInvoiceTypes },
	{ id: 'SE', name: 'Suecia', invoiceTypes: globalInvoiceTypes },
	{ id: 'CH', name: 'Suiza', invoiceTypes: globalInvoiceTypes },
	{ id: 'TW', name: 'Taiwan', invoiceTypes: globalInvoiceTypes },
	{ id: 'UY', name: 'Uruguay', invoiceTypes: globalInvoiceTypes },
	{ id: 'VE', name: 'Venezuela', invoiceTypes: globalInvoiceTypes }
]

const frequencies = [
  {
    id: 'weekly',
    name: 'semanal',
    unit: 'semana',
    plural: 'semanas'
  },
  {
    id: 'every_fifteen_days',
    name: 'cada 15 días',
    unit: 'quincena',
    plural: 'quincenas'
  },
  {
    id: 'monthly',
    name: 'mensual',
    unit: 'mes',
    plural: 'meses'
  },
  {
    id: 'bimonthly',
    name: 'cada 2 meses',
    unit: 'bimestre',
    plural: 'bimestres'
  },
  {
    id: 'quarterly',
    name: 'cada 3 meses',
    unit: 'trimestre',
    plural: 'trimestres'
  },
  {
    id: 'biannual',
    name: 'cada 6 meses',
    unit: 'semestre',
    plural: 'semestres'
  },
  {
    id: 'annual',
    name: 'anual',
    unit: 'año',
    plural: 'años'
  }
]

export default {
  directives: {
    dni: {
      update: function (el, binding, vnode) {
        let country = binding.value || 'CL'
        if (vnode.context.listenerAttached) {
          el.removeEventListener('input', vnode.context.rutFunction)
          vnode.context.listenerAttached = false
        }
        vnode.context.rutFunction = (e) => {
          vnode.componentInstance.$emit('input', country === 'CL' ? rutFormat(e.target.value) : e.target.value)
        }
        el.addEventListener('input', vnode.context.rutFunction)
        vnode.context.listenerAttached = true
      }
    }
  },
  data: () => ({
    baseCountries: baseCountries,
    currencies: currencies,
    currentMonth: moment().format('MMMM'),
    frequencies: frequencies,
    error: null,
    today: moment().format('YYYY-MM-DD')
  }),
  filters: {
    currency (value, id) {
      const currency = currencies.find(c => c.id === id)
      if (!currency) {
        return value
      }
      const options = Object.assign({}, currency.format, { symbol: '' })
      return formatMoney(value, options)
    },
    frequency (value, type = 'name') {
      const frequency = frequencies.find(c => c.id === value)
      if (!frequency) {
        return value
      }
      return frequency[type]
    },
    number (val, rounded = true) {
      numeral.localeData().delimiters.thousands = rounded ? '.' : ','
      numeral.localeData().delimiters.decimal = rounded ? ',' : '.'
      return numeral(val).format(rounded ? '0,0' : '0,0.00')
    },
    date (val) {
      return moment(val).format('DD MMM YYYY')
    },
    dateConditional (val) {
      return moment(val, "hmm").format("HH:mm") > '24:00' ? moment(val).format('DD MMM YYYY hh:mm') : moment(val).fromNow()
    },
    dateTime (val) {
      return moment(val).format('DD MMM YYYY hh:mm')
    },
    dateFromNow (val) {
      if (!val) {
        return null
      }
      return moment(val).fromNow()
    },
    capitalize (val) {
      return `${val.toString().charAt(0).toUpperCase()}${val.toString().slice(1)}`
    }
  },
  methods: {
    filterChoices (field = null, property = null) {
      const nestedProperty = (obj, path) => path.split('.').reduce((o, p) => o[p], obj)

      if (field && property) {
        if (this.filteredChoices[field].search && this.filteredChoices[field].search.length >= 3) {
          this.filteredChoices[field].items = nestedProperty(this, property).filter(item =>
            item.name.toLowerCase().includes(this.filteredChoices[field].search.toLowerCase())
          )
        } else {
          this.filteredChoices[field].items = []
        }
      }
    },
    sumProperty (arr, prop) {
      /**
       * Return sum property in objects array
       * @param arr objects array to iterate
       * @param prop string name property
       */
      if (arr.length) {
        return arr.map(element => parseInt(element[prop])).reduce((a, b) => a + b)
      }
      return 0
    },
    formatNumber (value, round = true) {
      if (round) {
        return Math.round(value)
      }
      return value
    },
    parseErrorsDict (dict, translate = 'api') {
      const containerTemplate = template('<ul class="error-Item"><%= content %></ul>')
      let output = []
      each(dict, (value, key) => {
        const fieldTemplate = template(
          '<li class="error-Field"><span class="error-Field--Name"><%= name %></span> <%= content %></li>'
        )
        const valueTemplate = template(
          '<span class="error-Field-Value"><%= value %></span>'
        )
        let plainValue = null
        let listValue = null
        let content = null
        if (isString(value)) {
          plainValue = value
        } else if (isArray(value)) {
          if (isString(value[0])) {
            plainValue = value.join(' ')
          } else {
            listValue = this.parseErrorsList(value)
          }
        }
        if (plainValue) {
          content = valueTemplate({ value: plainValue })
        } else if (listValue) {
          content = listValue
        }
        if (content) {
          if (translate) {
            if (key.search(/_(\d+)$/) !== -1) {
              const values = key.split('_')
              key = this.$t(`${translate}.${values[0]}`, {number: values[1]})
            } else {
              key = this.$t(`${translate}.${key}`)
            }
          }
          output.push(fieldTemplate({
            name: key,
            content: content
          }))
        }
      })
      output = output.join(' ')
      if (output) {
        output = containerTemplate({ content: output })
      }
      return output
    },
    parseErrorsList (list, translate = 'api') {
      const containerTemplate = template('<%= content %>')
      let output = []
      each(list, (dict, index) => {
        if (!isEmpty(dict)) {
          output.push(this.parseErrorsDict(dict, translate))
        }
      })
      output = output.join(' ')
      if (output) {
        output = containerTemplate({ content: output })
      }
      return output
    },
    parseErrors (data, translate = 'api') {
      if (isArray(data)) {
        return this.parseErrorsList(data, translate)
      } else {
        return this.parseErrorsDict(data, translate)
      }
    },
    toClipboard (string) {
      /**
       * Copy text to clipboard
       * @param string text to copy
       */
      this.$copyText(string)
      .then(() => {
        this.$dialog.message.info('Copiado')
      })
    }
  }
}
